// extracted by mini-css-extract-plugin
module.exports = {"file":"SupportCaseFilesList_file__1B247","fileIcon":"SupportCaseFilesList_fileIcon__A2w5b"};